/**
 * Created by Ning Jiang on 10/26/2018.
 */



require("pixi-particles");

import {AnimatedParticle, Emitter, OldEmitterConfig} from "pixi-particles";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { TimeCheckPoints } from "@nolimitcity/slot-game/bin/core/utils/TimeCheckPoints";
import { TimelineMax } from "gsap";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";

export class BigWinParticleController {
    
    private loopTl:TimelineMax | null;
    
    private _emitter:Emitter;
    private _timeName:string = "";

    private deltaTime:number = 0;
    
    private get elapsedTime():number{
        return TimeCheckPoints.getCheckPointTime(this._timeName);
    }

    private set timeName(name:string){
        this._timeName = name;
        TimeCheckPoints.setCheckPoint(name);
    }
    
    constructor(type:string, layer:PIXI.Container, config:any, isManiac:boolean = false){
        this.timeName = type;

        let partTextures:any[] = [];

        if(isManiac){
            partTextures = [{
                framerate : 20,
                loop : false,
                // hasLoaded : true,
                textures : GameResources.getTextures("Toapapper"),
            }];
        }else{
            partTextures = [ 
                {
                framerate : 1,
                loop : true,
                hasLoaded : true,
                textures : GameResources.getTextures("Particles/Cig"),
                },
                {
                    framerate : 1,
                    loop : true,
                    hasLoaded : true,
                    textures : GameResources.getTextures("Big_Win/Note"),
                },
                {
                    framerate : 1,
                    loop : true,
                    hasLoaded : true,
                    textures : GameResources.getTextures("Big_Win/Note2"),
                },
            ]
        }

        this._emitter = new Emitter(layer, partTextures, config);
        this._emitter.particleConstructor = AnimatedParticle;
        this._emitter.emit = false;
    }

    private update():void {
        this._emitter.update((this.elapsedTime - this.deltaTime)* 0.001)
        this.deltaTime = this.elapsedTime;
    }

    public enableEmit(value:boolean):void {
        if(value && !this.loopTl){
            this.loopTl = new TimelineMax({
                repeat:-1,
                onUpdate:() => this.update(),
                onRepeat:() => { if(this._emitter.particleCount == 0) this.loopTl = Helper.timeLineNuller(this.loopTl) }
            });
            this.loopTl.to(this,1,{});
            this.loopTl.play();
            this.deltaTime = this.elapsedTime;

        } 
        this._emitter.emit = value;
    }

    public setPos(newPos:PIXI.Point):void{
        this._emitter.spawnPos.copyFrom(newPos);
    }
}